"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _cleanProps = _interopRequireDefault(require("../utils/cleanProps"));

var _clear = _interopRequireDefault(require("./clear"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Input =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Input, _PureComponent);

  function Input(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "defaultInfo", function (value) {
      if (!value || value.length === 0) return null;
      var info = _this.props.info;
      var text = value.length + " / " + info;
      if (value.length <= info) return text;
      return new Error(text);
    });

    _this.enterLock = false;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Input.prototype;

  _proto.bindRef = function bindRef(el) {
    var forwardedRef = this.props.forwardedRef;
    this.ref = el;
    if (forwardedRef) forwardedRef(el);
  };

  _proto.invalidNumber = function invalidNumber(value) {
    var _this$props = this.props,
        digits = _this$props.digits,
        type = _this$props.type;
    if (type !== 'number') return false;
    var reg = '^-?\\d*';

    if (digits === undefined) {
      reg += '\\.?\\d*';
    } else if (digits > 0) {
      reg += "\\.?\\d{0," + digits + "}";
    }

    reg += '$';
    reg = new RegExp(reg);
    return !reg.test(value);
  };

  _proto.handleChange = function handleChange(e, clearClick) {
    var _this$props2 = this.props,
        type = _this$props2.type,
        clearable = _this$props2.clearable,
        digits = _this$props2.digits;

    if (clearClick) {
      this.ref.focus();
      if (typeof clearable === 'function') clearable();
    }

    var value = e.target.value;
    if (type === 'number' && typeof value !== 'number') value = String(value).replace(/。/g, '.');

    if (this.invalidNumber(value)) {
      // For numbers with a decimal point, use toFixed to correct the number of decimal points.
      if (digits >= 0 && /^-?\d*\.?\d*$/.test(value)) {
        value = digits === 0 ? Number(value).toFixed(digits) : Number(value).toFixed(digits + 1).slice(0, -1);
      } else {
        // digits <= 0 || not of number
        return;
      }
    }

    this.props.onChange(value);
  };

  _proto.handleKeyDown = function handleKeyDown(e) {
    var onKeyDown = this.props.onKeyDown;
    if (e.keyCode === 13) this.enterPress = true;
    if (onKeyDown) onKeyDown(e);
  };

  _proto.handleKeyUp = function handleKeyUp(e) {
    var _this$props3 = this.props,
        onKeyUp = _this$props3.onKeyUp,
        onEnterPress = _this$props3.onEnterPress;

    if (this.enterPress && e.keyCode === 13 && onEnterPress) {
      onEnterPress(e.target.value, e);
      this.enterPress = false;
    }

    if (onKeyUp) onKeyUp(e);
  };

  _proto.handleBlur = function handleBlur(e) {
    var value = e.target.value;
    var _this$props4 = this.props,
        forceChange = _this$props4.forceChange,
        onBlur = _this$props4.onBlur;
    if (onBlur) onBlur(e);
    if (this.invalidNumber(value)) return;
    if (forceChange) forceChange(value);
  };

  _proto.renderInfo = function renderInfo() {
    var info = this.props.info;
    var notNumber = typeof info !== 'number';
    if (typeof info !== 'function' && notNumber) return null;
    var textInfo = notNumber ? info : this.defaultInfo;
    var res = textInfo(this.props.value); // empty

    if (!res) return null;
    var isError = res instanceof Error;
    var text = isError ? res.message : res;
    return _react.default.createElement("div", {
      key: "info",
      style: {
        minWidth: 'auto'
      },
      className: (0, _styles.inputClass)('bottom-right', isError ? 'error' : 'tip')
    }, text);
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        type = _this$props5.type,
        defaultValue = _this$props5.defaultValue,
        digits = _this$props5.digits,
        className = _this$props5.className,
        clearable = _this$props5.clearable,
        htmlName = _this$props5.htmlName,
        forceChange = _this$props5.forceChange,
        onEnterPress = _this$props5.onEnterPress,
        forwardedRef = _this$props5.forwardedRef,
        other = _objectWithoutPropertiesLoose(_this$props5, ["type", "defaultValue", "digits", "className", "clearable", "htmlName", "forceChange", "onEnterPress", "forwardedRef"]);

    var value = this.props.value == null ? '' : this.props.value;
    var showClear = !other.disabled && clearable && value !== '';
    var mc = (0, _classnames.default)(className, showClear && (0, _styles.inputClass)('clearable'));
    return [_react.default.createElement("input", _extends({}, (0, _cleanProps.default)(other), {
      className: mc || undefined,
      name: other.name || htmlName,
      type: type === 'password' ? type : 'text',
      value: value,
      ref: this.bindRef,
      key: "input",
      onChange: this.handleChange,
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp,
      onBlur: this.handleBlur
    })), showClear && _react.default.createElement(_clear.default, {
      onClick: this.handleChange,
      key: "close"
    }), this.renderInfo()];
  };

  return Input;
}(_react.PureComponent);

Input.propTypes = {
  className: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  digits: _propTypes.default.number,
  forceChange: _propTypes.default.func,
  htmlName: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func.isRequired,
  onEnterPress: _propTypes.default.func,
  type: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onFocus: _propTypes.default.func,
  clearable: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
  info: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.number]),
  forwardedRef: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onKeyUp: _propTypes.default.func
};
Input.defaultProps = {
  type: 'text'
};
var _default = Input;
exports.default = _default;